export class EventBus {}

export class UnauthorizedEventBus extends EventBus {}
